import { toastHelper } from '../../../util/toastHelper'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import CheckBoxCustom from '../../atoms/checkbox/CheckBox'
import InputCustom from '../../atoms/input/InputCustom'
import GoogleAddressInput from '../../atoms/input/GoogleAddressInput'
import styles from '../onboarding.module.scss'

export const VendorInfo = ({ userDetails, setUserDetails, setStep }) => {
	const handlePlaceSelected = (placeData) => {
		setUserDetails({
			...userDetails,
			businessAddress: placeData.formattedAddress,
		})
	}
	const handleSubmit = async (e) => {
		e.preventDefault()
        
		const { firstName, lastName, businessName, businessAddress } =
			userDetails

		if (
			!firstName.trim() ||
			!lastName.trim() ||
			!businessName.trim() ||
			!businessAddress.trim()
		) {
			return toastHelper('Please fill out all fields', 'error')
		}

        if(userDetails.hasActivationCode && !userDetails.activationCode.trim().length) return toastHelper('Please enter the Wedding Join Code', 'error')
		setStep((step) => step + 1)
	}

	return (
		<div className={styles.form}>
			<h1>{userDetails.type === 'vendor' ? 'Vendor' : 'Venue'}</h1>
			<form className={styles.form} onSubmit={handleSubmit}>
				<div className={styles.formGroup}>
					<InputCustom
						data-cy="firstName"
						placeholder="First Name"
						name="firstName"
						type="text"
						value={userDetails.firstName}
						autoFocus={true}
						setDataFunction={setUserDetails}
						data={userDetails}
						required={true}
					/>
				</div>
				<div className={styles.formGroup}>
					<InputCustom
						data-cy="lastName"
						placeholder="Last Name"
						name="lastName"
						type="text"
						value={userDetails.lastName}
						setDataFunction={setUserDetails}
						data={userDetails}
						required={true}
					/>
				</div>
				<div className={styles.formGroup}>
					<InputCustom
						data-cy="businessName"
						placeholder="Business Name"
						name="businessName"
						type="text"
						value={userDetails.businessName}
						setDataFunction={setUserDetails}
						data={userDetails}
						required={true}
					/>
				</div>
				<div className={styles.formGroup}>
					<GoogleAddressInput
						data-cy="businessAddress"
						placeholder="Business Address"
						name="businessAddress"
						value={userDetails.businessAddress}
						setDataFunction={setUserDetails}
						data={userDetails}
						onPlaceSelected={handlePlaceSelected}
						required={true}
					/>
				</div>
				<div className={styles.formGroup}>
                    <CheckBoxCustom
                        checked={userDetails.hasActivationCode}
                        onChange={() => {
                            setUserDetails({
                                ...userDetails,
                                hasActivationCode: !userDetails.hasActivationCode,
								activationCode: !userDetails.hasActivationCode ? userDetails.activationCode : ''
                            })
                        }}
                        label='Wedding Join Code?'
                        lineColor='#7ca6bd'
                        labelColor='#7ca6bd'
                    />
                    {
                        userDetails.hasActivationCode &&
                        <InputCustom
                            data-cy="activationCode"
                            placeholder="Wedding Join Code (If you got invited to a wedding)"
                            name="activationCode"
                            type="text"
                            value={userDetails.activationCode}
                            setDataFunction={setUserDetails}
                            data={userDetails}
                        />
                    }
				</div>
				<div className={`${styles.bottomButtons} ${styles.skipBtn}`}>
					<button
						data-cy="backButton"
						onClick={() => {
							setStep((step) => step - 1)
							setUserDetails({ ...userDetails, type: '' })
						}}
						className="backButton"
					>
						Back
					</button>
					<ButtonCustom type="submit" data-cy="nextButton">
						Next
					</ButtonCustom>
				</div>
			</form>
		</div>
	)
}
